import Creator from "./Creator";
import List from "./List";

const pages = { Creator, List };

export default pages;
